import React, { useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import TransaccionesVentaProducto from './TransaccionesVentaProducto';
import TransaccionesCompraProducto from './TransaccionesCompraProducto';
import VistaEstadisticasProducto from './TransaccionesEstadisticasProducto';

const TabsTransaccionesProducto = ({ token, id_producto, es_padre}) => {
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <div>
            <Tabs value={activeTab} onChange={handleTabChange} centered>
                <Tab label="Estadísticas" />
                <Tab label="Ventas" />
                <Tab label="Compras" />
            </Tabs>
            <div className="mt-4">
                {activeTab === 0 && <VistaEstadisticasProducto id_producto={id_producto} token={token} />}
                {activeTab === 1 && <TransaccionesVentaProducto id_producto={id_producto} es_padre={es_padre} token={token} />}
                {activeTab === 2 && <TransaccionesCompraProducto id_producto={id_producto} es_padre={es_padre} token={token} />}
            </div>
        </div>
    );
};

export default TabsTransaccionesProducto;